import { useEffect, useRef } from 'react';

export function useRequestAnimationFrame(callback: () => void) {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        let handle = requestAnimationFrame(function tick() {
            handle = requestAnimationFrame(tick);
            callbackRef.current();
        });

        return () => cancelAnimationFrame(handle);
    }, []);
}
